export type DashboardWidgetDataType =
  | 'distribution'
  | 'count'
  | 'timeseries'
  | 'rank'
  | 'pair'
  | 'stub';

export class DashboardWidgetDataPointEntity {
  public key!: string;
  public label!: string;
  public value!: number;
  public color!: string | null;
  public filter!: string | null;
}

export class DashboardWidgetDataEntity {
  public widgetKey!: string;
  public type!: DashboardWidgetDataType;
  public data!: DashboardWidgetDataPointEntity[];
}
